<template>
  <div>
    <div class="containter-fluid">
      <div class="row ld-top-header">
        <div class="container ld-top-header-inner">
          <img src="@/assets/images/landing-new/next360_logo.svg" alt="next360_logo">
          <p>Giải pháp Chuyển đổi số toàn diện cho doanh nghiệp</p>
        </div>
      </div>
    </div>

    <div class="container-fluid ld-nav-menu-wrapper">
      <div class="row">
        <div class="container ld-nav-menu">
          <b-navbar toggleable="lg" type="light">
            <b-navbar-brand :href="`/home`">
              <img src="@/assets/images/nextshop-logo.svg" alt="nextshop-logo">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item href="#">Ngành hàng</b-nav-item>
                <b-nav-item :href="`/pricing`">Bảng giá</b-nav-item>
                <b-nav-item href="#">Hướng dẫn</b-nav-item>
                <b-nav-item href="#">Về Next360</b-nav-item>
                <b-nav-item href="https://pos.nextshop.mobi/">Đăng nhập bản cũ</b-nav-item>
                <b-nav-item :href="loginLink">Dùng ngay</b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>

    <div class="container-fluid ld-pricing">
      <div class="container">
        <div class="ld-section-heading text-center">
          <img src="@/assets/images/landing-new/ice-tea.svg" alt="bảng giá nextshop">
          <h2>Quản lý cửa hàng với chi phí 1 cốc trà đá mỗi ngày</h2>
          <p>NextShop có các gói theo từng nhu cầu và quy mô cửa hàng của bạn</p>
        </div>

        <div class="row">
          <div class="ld-trial-package">
            <div class="block-img-text">
              <img src="@/assets/images/landing-new/laptop-1.svg" alt="nextshop gói dùng thử 2 tuần">
              <div class="block-des">
                <h2>2 tuần</h2>
                <h1>Gói dùng thử miễn phí</h1>
                <ul>
                  <li>Khởi tạo nhanh chóng</li>
                  <li>Đầy đủ tính năng như bản trả phí</li>
                </ul>
              </div>
            </div>
            <div class="cta-button">
              <b-button variant="light" @click="toLogin">Dùng thử ngay <i class='bx bx-right-arrow-alt fz-24'></i></b-button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 ld-accordion-wrapper">
            <div class="accordion" role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <b-button block v-b-toggle.accordion-1>
                    Gói Cơ bản
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <ul>
                      <li>Giới hạn mở 1 chi nhánh</li>
                      <li>Không giới hạn số đơn hàng 1 ngày</li>
                      <li>Hỗ trợ thanh toán quẹt thẻ MPOS</li>
                    </ul>
                    <div class="dps-button"><button type="button" @click="toSignup" class="btn btn-default btn-outline-default">Liên hệ để đăng ký</button></div>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <b-button block v-b-toggle.accordion-2>
                    Gói Nâng cao - 3 chi nhánh
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <ul>
                      <li>Có thể mở lên đến 3 chi nhánh</li>
                      <li>Không giới hạn số tài khoản nhân viên</li>
                      <li>Không giới hạn số đơn hàng 1 ngày</li>
                      <li>Hỗ trợ thanh toán quẹt thẻ MPOS</li>
                    </ul>
                    <div class="dps-button"><button type="button" @click="toSignup" class="btn btn-default btn-outline-default">Liên hệ để đăng ký</button></div>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <b-button block v-b-toggle.accordion-3>
                    Gói Nâng cao - 5 chi nhánh
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <ul>
                      <li>Có thể mở lên đến 5 chi nhánh</li>
                      <li>Không giới hạn số tài khoản nhân viên</li>
                      <li>Không giới hạn số đơn hàng 1 ngày</li>
                      <li>Hỗ trợ thanh toán quẹt thẻ MPOS</li>
                    </ul>
                    <div class="dps-button"><button type="button" @click="toSignup" class="btn btn-default btn-outline-default">Liên hệ để đăng ký</button></div>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <b-button block v-b-toggle.accordion-4>
                    Gói Nâng cao - 10 chi nhánh
                  </b-button>
                </b-card-header>
                <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <ul>
                      <li>Có thể mở lên đến 10 chi nhánh</li>
                      <li>Không giới hạn số tài khoản nhân viên</li>
                      <li>Không giới hạn số đơn hàng 1 ngày</li>
                      <li>Hỗ trợ thanh toán quẹt thẻ MPOS</li>
                    </ul>
                    <div class="dps-button"><button type="button" @click="toSignup" class="btn btn-default btn-outline-default">Liên hệ để đăng ký</button></div>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid ld-info">
      <div class="row">
        <div class="col-lg-12 ld-info-text">
          <img src="@/assets/images/landing-new/next360-rounded-sm.svg" alt="next360">
          <p>Một sản phẩm trong hệ sinh thái Next360</p>
        </div>
      </div>
    </div>
  <NPFooter />
  </div>
</template>

<script>
import NPFooter from './NPFooter'

export default {
  components: {
    NPFooter,
  },
  data() {
    return {
      loading: false,
      loginLink: '',
      signupLink: '',
    }
  },
  created() {
    this.loginLink = `${process.env.VUE_APP_LOGIN}/login?appId=5efef20c4521fd3aaabf4197&redirectUri=${encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)}`
    this.signupLink = `${process.env.VUE_APP_LOGIN}/signup?appId=5efef20c4521fd3aaabf4197&redirectUri=${encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)}`
  },
  methods: {
    toLogin() {
      window.open(this.loginLink)
    },
    toSignup() {
      window.open(this.signupLink)
    }
  }
}
</script>
<style scoped>
.dps-button {
  text-align: center;
  display: inline-block;
  width: 100%;
  margin-top: 20px;
}
.btn-outline-default{
  background: #fff;
  color: #3e69f6;
}
</style>
